const locationsRo = [
  {
    id: 7909,
    city: "Alghero",
    address: "Alghero Airport",
    code: "AHO",
    value: "AHO",
    destination_translations: "",
    language: "ro",
    country: "Italia"
  },
  {
    id: 7910,
    city: "Amman",
    address: "Queen Alia International Airport",
    code: "AMM",
    value: "AMM",
    destination_translations: "",
    language: "ro",
    country: "Iordania"
  },
  {
    id: 7920,
    city: "Amsterdam",
    address: "Schiphol Airport",
    code: "AMS",
    value: "AMS",
    destination_translations: "",
    language: "ro",
    country: "Olanda"
  },
  {
    id: 7922,
    city: "Ankara",
    address: "Ankara Esenboga Airport",
    code: "ESB",
    value: "ESB",
    destination_translations: "",
    language: "ro",
    country: "Turcia"
  },
  {
    id: 7923,
    city: "Antalya",
    address: "Antalya Airport",
    code: "AYT",
    value: "AYT",
    destination_translations: "",
    language: "ro",
    country: "Turcia"
  },
  {
    id: 7924,
    city: "Atena",
    address: "Athens International Airport Eleftherios Venizelos",
    code: "ATH",
    value: "ATH",
    destination_translations: "",
    language: "ro",
    country: "Grecia"
  },
  {
    id: 7926,
    city: "Barcelona",
    address: "Barcelona-El Prat Airport",
    code: "BCN",
    value: "BCN",
    destination_translations: "",
    language: "ro",
    country: "Spania"
  },
  {
    id: 7927,
    city: "Bari",
    address: "Bari Karol Wojtyła Airport",
    code: "BRI",
    value: "BRI",
    destination_translations: "",
    language: "ro",
    country: "Italia"
  },
  {
    id: 7940,
    city: "Beirut",
    address: "Beirut–Rafic Hariri International Airport",
    code: "BEY",
    value: "BEY",
    destination_translations: "",
    language: "ro",
    country: "Liban"
  },
  {
    id: 7941,
    city: "Belgrade",
    address: "Belgrade Nikola Tesla Airport",
    code: "BEG",
    value: "BEG",
    destination_translations: "",
    language: "ro",
    country: "Serbia"
  },
  {
    id: 7942,
    city: "Bilbao",
    address: "Bilbao Airport",
    code: "BIO",
    value: "BIO",
    destination_translations: "",
    language: "ro",
    country: "Spania"
  },
  {
    id: 7943,
    city: "Bodrum",
    address: "Milas–Bodrum Airport",
    code: "BJV",
    value: "BJV",
    destination_translations: "",
    language: "ro",
    country: "Turcia"
  },
  {
    id: 7944,
    city: "Bologna",
    address: "Bologna Guglielmo Marconi Airport",
    code: "BLQ",
    value: "BLQ",
    destination_translations: "",
    language: "ro",
    country: "Italia"
  },
  {
    id: 7951,
    city: "Brindisi",
    address: "Brindisi Papola Casale Airport",
    code: "BDS",
    value: "BDS",
    destination_translations: "",
    language: "ro",
    country: "Italia"
  },
  {
    id: 7952,
    city: "Bruxelles",
    address: "Brussels Airport",
    code: "BRU",
    value: "BRU",
    destination_translations: "",
    language: "ro",
    country: "Belgia"
  },
  {
    id: 7953,
    city: "Bucuresti",
    address: "Henri Coanda Airport",
    code: "OTP",
    value: "OTP",
    destination_translations: "București\nBucuresti\nBucharest\nBucarest\nBukarest\nHenri Coanda\nHenri Coandă\nRoumanie\nRomânia\nRomania",
    language: "ro",
    country: "România"
  },
  {
    id: 7954,
    city: "Budapesta",
    address: "Budapest Ferenc Liszt International Airport",
    code: "BUD",
    value: "BUD",
    destination_translations: "",
    language: "ro",
    country: "Ungaria"
  },
  {
    id: 7955,
    city: "Cagliari",
    address: "Cagliari Elmas Airport",
    code: "CAG",
    value: "CAG",
    destination_translations: "",
    language: "ro",
    country: "Italia"
  },
  {
    id: 7956,
    city: "Cairo",
    address: "Cairo International Airport",
    code: "CAI",
    value: "CAI",
    destination_translations: "",
    language: "ro",
    country: "Egipt"
  },
  {
    id: 7957,
    city: "Catania",
    address: "Catania–Fontanarossa Airport",
    code: "CTA",
    value: "CTA",
    destination_translations: "",
    language: "ro",
    country: "Italia"
  },
  // {
  //   id: 7958,
  //   city: "Chisinau",
  //   address: "Chisinau International Airport",
  //   code: "KIV",
  //   value: "KIV",
  //   destination_translations: "",
  //   language: "ro",
  //   country: "Moldova"
  // },
  {
    id: 7965,
    city: "Cluj-Napoca",
    address: "Avram Iancu Cluj International Airport",
    code: "CLJ",
    value: "CLJ",
    destination_translations: "",
    language: "ro",
    country: "România"
  },
  {
    id: 7973,
    city: "Detroit",
    address: "Detroit Metropolitan Wayne County Airport",
    code: "DTW",
    value: "DTW",
    destination_translations: "",
    language: "ro",
    country: "Statele Unite ale Americii"
  },
  {
    id: 7974,
    city: "Frankfurt",
    address: "Frankfurt Airport",
    code: "FRA",
    value: "FRA",
    destination_translations: "",
    language: "ro",
    country: "Germania"
  },
  {
    id: 7975,
    city: "Genova",
    address: "Genova City Airport",
    code: "GOA",
    value: "GOA",
    destination_translations: "",
    language: "ro",
    country: "Italia"
  },
  {
    id: 7976,
    city: "Gran Canaria",
    address: "Gran Canaria Airport",
    code: "LPA",
    value: "LPA",
    destination_translations: "",
    language: "ro",
    country: "Spania"
  },
  {
    id: 7983,
    city: "Iasi",
    address: "Iasi International Airport",
    code: "IAS",
    value: "IAS",
    destination_translations: "Iași\nIaşi\nIasi\nRoumanie\nRomânia\nRomania",
    language: "ro",
    country: "România"
  },
  {
    id: 7984,
    city: "Istanbul",
    address: "Istanbul Airport",
    code: "IST",
    value: "IST",
    destination_translations: "",
    language: "ro",
    country: "Turcia"
  },
  {
    id: 7985,
    city: "Izmir",
    address: "İzmir Adnan Menderes Airport",
    code: "ADB",
    value: "ADB",
    destination_translations: "",
    language: "ro",
    country: "Turcia"
  },
  {
    id: 7993,
    city: "Milano",
    address: "Milan Linate Airport",
    code: "LIN",
    value: "LIN",
    destination_translations: "",
    language: "ro",
    country: "Italia"
  },
  {
    id: 8000,
    city: "Lisabona",
    address: "Humberto Delgado Airport",
    code: "LIS",
    value: "LIS",
    destination_translations: "",
    language: "ro",
    country: "Portugalia"
  },
  {
    id: 8007,
    city: "Londra",
    address: "Heathrow Airport",
    code: "LHR",
    value: "LHR",
    destination_translations: "",
    language: "ro",
    country: "Marea Britanie"
  },
  {
    id: 8014,
    city: "Lyon",
    address: "Lyon-Saint Exupéry Airport",
    code: "LYS",
    value: "LYS",
    destination_translations: "",
    language: "ro",
    country: "Franta"
  },
  {
    id: 8021,
    city: "Madrid",
    address: "Adolfo Suárez Madrid–Barajas Airport",
    code: "MAD",
    value: "MAD",
    destination_translations: "",
    language: "ro",
    country: "Spania"
  },
  {
    id: 8028,
    city: "Malaga",
    address: "Malaga-Costa del Sol Airport",
    code: "AGP",
    value: "AGP",
    destination_translations: "",
    language: "ro",
    country: "Spania"
  },
  {
    id: 8035,
    city: "Marsilia",
    address: "Marseille Provence Airport",
    code: "MRS",
    value: "MRS",
    destination_translations: "",
    language: "ro",
    country: "Franta"
  },
  {
    id: 8042,
    city: "Montpellier",
    address: "Montpellier–Méditerranée Airport",
    code: "MPL",
    value: "MPL",
    destination_translations: "",
    language: "ro",
    country: "Franta"
  },
  {
    id: 8063,
    city: "Napoli",
    address: "Naples International Airport",
    code: "NAP",
    value: "NAP",
    destination_translations: "",
    language: "ro",
    country: "Italia"
  },
  {
    id: 8077,
    city: "Nisa",
    address: "Cote d'Azur Airport",
    code: "NCE",
    value: "NCE",
    destination_translations: "",
    language: "ro",
    country: "Franta"
  },
  {
    id: 8084,
    city: "Oradea",
    address: "Oradea International Airport",
    code: "OMR",
    value: "OMR",
    destination_translations: "",
    language: "ro",
    country: "România"
  },
  {
    id: 8091,
    city: "Palermo",
    address: "Falcone Borsellino Airport",
    code: "PMO",
    value: "PMO",
    destination_translations: "",
    language: "ro",
    country: "Italia"
  },
  {
    id: 8098,
    city: "Palma de Mallorca",
    address: "Palma De Mallorca",
    code: "PMI",
    value: "PMI",
    destination_translations: "",
    language: "ro",
    country: "Spania"
  },
  {
    id: 8105,
    city: "Paris",
    address: "Charles de Gaulle Airport",
    code: "CDG",
    value: "CDG",
    destination_translations: "",
    language: "ro",
    country: "Franta"
  },
  {
    id: 8112,
    city: "Pau",
    address: "Pau Pyrénées Airport",
    code: "PUF",
    value: "PUF",
    destination_translations: "",
    language: "ro",
    country: "Franta"
  },
  {
    id: 8119,
    city: "Praga",
    address: "Vaclav Havel Airport Prague",
    code: "PRG",
    value: "PRG",
    destination_translations: "",
    language: "ro",
    country: "Cehia"
  },
  {
    id: 8126,
    city: "Riad",
    address: "King Khalid International Airport",
    code: "RUH",
    value: "RUH",
    destination_translations: "",
    language: "ro",
    country: "Arabia Saudită"
  },
  {
    id: 8133,
    city: "Riga",
    address: "Riga International Airport",
    code: "RIX",
    value: "RIX",
    destination_translations: "",
    language: "ro",
    country: "Letonia"
  },
  {
    id: 8140,
    city: "Roma",
    address: "Fiumicino Leonardo da Vinci Airport",
    code: "FCO",
    value: "FCO",
    destination_translations: "",
    language: "ro",
    country: "Italia"
  },
  {
    id: 8147,
    city: "Salonic",
    address: "Thessaloniki Airport Makedonia",
    code: "SKG",
    value: "SKG",
    destination_translations: "",
    language: "ro",
    country: "Grecia"
  },
  {
    id: 8161,
    city: "Sofia",
    address: "Sofia International Airport",
    code: "SOF",
    value: "SOF",
    destination_translations: "",
    language: "ro",
    country: "Bulgaria"
  },
  {
    id: 8168,
    city: "Strasbourg",
    address: "Strasbourg Airport",
    code: "SXB",
    value: "SXB",
    destination_translations: "",
    language: "ro",
    country: "Franta"
  },
  {
    id: 8175,
    city: "Suceava",
    address: "Stefan Cel Mare International Airport",
    code: "SCV",
    value: "SCV",
    destination_translations: "",
    language: "ro",
    country: "România"
  },
  {
    id: 8189,
    city: "Tampere",
    address: "Tampere–Pirkkala Airport",
    code: "TMP",
    value: "TMP",
    destination_translations: "",
    language: "ro",
    country: "Finlanda"
  },
  {
    id: 8196,
    city: "Tel Aviv",
    address: "Ben Gurion International Airport",
    code: "TLV",
    value: "TLV",
    destination_translations: "",
    language: "ro",
    country: "Israel"
  },
  {
    id: 8203,
    city: "Tenerife",
    address: "Tenerife North Airport",
    code: "TFN",
    value: "TFN",
    destination_translations: "",
    language: "ro",
    country: "Spania"
  },
  {
    id: 8210,
    city: "Timisoara",
    address: "Timisoara Traian Vuia International Airport",
    code: "TSR",
    value: "TSR",
    destination_translations: "",
    language: "ro",
    country: "România"
  },
  {
    id: 8217,
    city: "Torino",
    address: "Turin International Airport",
    code: "TRN",
    value: "TRN",
    destination_translations: "",
    language: "ro",
    country: "Italia"
  },
  {
    id: 8224,
    city: "Toulouse",
    address: "Toulouse–Blagnac Airport",
    code: "TLS",
    value: "TLS",
    destination_translations: "",
    language: "ro",
    country: "Franta"
  },
  {
    id: 8253,
    city: "Vilnius",
    address: "Vilnius International Airport",
    code: "VNO",
    value: "VNO",
    destination_translations: "",
    language: "ro",
    country: "Lituania"
  },
  {
    id: 8260,
    city: "Washington",
    address: "Washington Dulles International Airport",
    code: "IAD",
    value: "IAD",
    destination_translations: "",
    language: "ro",
    country: "Statele Unite ale Americii"
  },
  {
    id: 11785,
    city: "Baia Mare",
    address: "Maramures International Airport",
    code: "BAY",
    value: "BAY",
    destination_translations: "",
    language: "ro",
    country: "România"
  },
  {
    id: 32922,
    city: "A Coruna",
    address: "A Coruna Airport",
    code: "LCG",
    value: "LCG",
    destination_translations: "La Coruna\nLa Coruña\nA Coruña\nA Coruña Airport\nA Coruña Airport",
    language: "ro",
    country: "Spania"
  },
  {
    id: 32926,
    city: "New York",
    address: "John F. Kennedy International Airport",
    code: "JFK",
    value: "JFK",
    destination_translations: "",
    language: "ro",
    country: "Statele Unite ale Americii"
  },
  {
    id: 32947,
    city: "Tirana",
    address: "Aeroporti Ndërkombëtar i Tiranës Nënë Tereza",
    code: "TIA",
    value: "TIA",
    destination_translations: "Tirana\nTiranë\nRinas\nAlbania\nShqipëri",
    language: "ro",
    country: "Albania"
  },
  {
    id: 44860,
    city: "Dublin",
    address: "Dublin Airport",
    code: "DUB",
    value: "DUB",
    destination_translations: "",
    language: "ro",
    country: "Irlanda"
  },
  {
    id: 44869,
    city: "Copenhaga",
    address: "Copenhagen Airport",
    code: "CPH",
    value: "CPH",
    destination_translations: "",
    language: "ro",
    country: "Danemarca"
  },
  {
    id: 44876,
    city: "Gothenburg",
    address: "Göteborg Landvetter Airport",
    code: "GOT",
    value: "GOT",
    destination_translations: "",
    language: "ro",
    country: "Suedia"
  },
  {
    id: 44883,
    city: "Stockholm",
    address: "Stockholm Arlanda Airport",
    code: "ARN",
    value: "ARN",
    destination_translations: "",
    language: "ro",
    country: "Suedia"
  },
  {
    id: 45582,
    city: "Florenta",
    address: "Amerigo Vespucci Airport",
    code: "FLR",
    value: "FLR",
    destination_translations: "",
    language: "ro",
    country: "Italia"
  },
  {
    id: 45588,
    city: "Reggio Calabria",
    address: "Reggio Calabria Airport",
    code: "REG",
    value: "REG",
    destination_translations: "",
    language: "ro",
    country: "Italia"
  },
  {
    id: 45599,
    city: "Porto",
    address: "Francisco Sá Carneiro Airport",
    code: "OPO",
    value: "OPO",
    destination_translations: "",
    language: "ro",
    country: "Portugalia"
  },
  {
    id: 45606,
    city: "Paris",
    address: "Aeroportul Paris Orly",
    code: "ORY",
    value: "ORY", 
    destination_translations: "",
    language: "ro",
    country: "Franța"
  },
  {
    id: 45607,
    city: "Chișinău",
    address: "Aeroportul Internațional Chișinău",
    code: "RMO",
    value: "RMO",
    destination_translations: "",
    language: "ro",
    country: "Republica Moldova"
  },
  {
    id: 46001,
    city: "Calgary",
    address: "Aeroportul Internațional Calgary",
    code: "YYC",
    value: "YYC",
    destination_translations: "Calgary\nCalgary Airport\nCanada",
    language: "ro",
    country: "Canada"
  },
  {
    id: 46002,
    city: "Toronto",
    address: "Aeroportul Internațional Toronto Pearson",
    code: "YYZ",
    value: "YYZ",
    destination_translations: "Toronto\nToronto Pearson\nPearson\nCanada",
    language: "ro",
    country: "Canada"
  },
  {
    id: 46003,
    city: "Vancouver",
    address: "Aeroportul Internațional Vancouver",
    code: "YVR",
    value: "YVR",
    destination_translations: "Vancouver\nVancouver Airport\nCanada",
    language: "ro",
    country: "Canada"
  },
  {
    id: 46004,
    city: "Boston",
    address: "Aeroportul Internațional Logan",
    code: "BOS",
    value: "BOS",
    destination_translations: "Boston\nLogan\nBoston Airport\nUnited States\nUSA",
    language: "ro",
    country: "Statele Unite ale Americii"
  },
  {
    id: 46005,
    city: "Las Vegas",
    address: "Aeroportul Internațional Harry Reid",
    code: "LAS",
    value: "LAS",
    destination_translations: "Las Vegas\nHarry Reid\nMcCarran\nUnited States\nUSA",
    language: "ro",
    country: "Statele Unite ale Americii"
  },
  {
    id: 46006,
    city: "Los Angeles",
    address: "Aeroportul Internațional Los Angeles",
    code: "LAX",
    value: "LAX",
    destination_translations: "Los Angeles\nLAX\nUnited States\nUSA",
    language: "ro",
    country: "Statele Unite ale Americii"
  },
  {
    id: 46007,
    city: "Seattle",
    address: "Aeroportul Internațional Seattle-Tacoma",
    code: "SEA",
    value: "SEA",
    destination_translations: "Seattle\nSeattle-Tacoma\nSeaTac\nUnited States\nUSA",
    language: "ro",
    country: "Statele Unite ale Americii"
  },
  {
    id: 46008,
    city: "San Francisco",
    address: "Aeroportul Internațional San Francisco",
    code: "SFO",
    value: "SFO",
    destination_translations: "San Francisco\nSFO\nUnited States\nUSA",
    language: "ro",
    country: "Statele Unite ale Americii"
  },
  {
    id: 46009,
    city: "Anchorage",
    address: "Aeroportul Internațional Ted Stevens Anchorage",
    code: "ANC",
    value: "ANC",
    destination_translations: "Anchorage\nTed Stevens\nAlaska\nUnited States\nUSA",
    language: "ro",
    country: "Statele Unite ale Americii"
  }
];

export default locationsRo;
